import { trackAddToCart } from '../../../../../../shared/analytics/e-commerce/trackAddToCart';
import { flatten } from '../../../../../../shared/utils/flatten';
import { IAncillary } from '../../../../../domain/ancillary/domain/models/IAncillary';
import { adaptAncillaryToItems } from './adapters/adaptAncillaryToItems';

export function trackSelectAncillaries(ancillaries: IAncillary[]) {
	const nestedItems = ancillaries.map(adaptAncillaryToItems);

	trackAddToCart({
		items: flatten(nestedItems),
	});
}
